export enum SubmodelSemanticId {
    CoffeeConsumptionContainer = 'https://xitaso.com/CoffeeConsumption',
    ReferenceCounterContainer = 'https://xitaso.com/ReferenceCounter',
    CarbonFootprintIRDI = '0173-1#01-AHE712#001',
    CarbonFootprint = 'https://admin-shell.io/idta/CarbonFootprint/ProductCarbonFootprint/0/9',
    TimeSeries = 'https://admin-shell.io/idta/TimeSeries/1/1',
    HierarchicalStructures = 'https://admin-shell.io/idta/HierarchicalStructures/1/0/Submodel',
    Nameplate = 'https://admin-shell.io/zvei/nameplate/1/0/Nameplate',
    BillOfApplications = 'https://xitaso.com/BillOfApplications',
}

